import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SelectLoginRetailers = ({ retailers, isOpen, onClose, LoginWithRetails }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 999,
    },
    container: {
      width: "800px",
      maxHeight: "600px",
      padding: "20px",
      borderRadius: "30px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    title: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "4px",
      marginTop: "10px",
    },
    description: {
      textAlign: "center",
      fontSize: "0.9rem",
      color: "#5C5C5C",
      marginBottom: "20px",
    },
    verifyButton: {
      opacity: selectedRetailerId === null ? 0.5 : 1,
      pointerEvents: selectedRetailerId === null ? "none" : "auto",
      padding: "10px 40px",
      backgroundColor: "#1b4497",
      color: "white",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
      marginLeft: "auto",
      marginRight: 0,
      marginBottom: "20px",
    },
  };

  const filteredRetailers = retailers.filter((retailer) =>
    retailer.retailer_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {isOpen && (
        <>
          <div style={styles.overlay} onClick={onClose}></div>
          <div style={styles.container}>
            <div>
              <p style={styles.title}>{t("Select your Store")}</p>
              <div className="flex flex-row justify-center">
                <p style={styles.description}>
                  {t("Please choose a store to continue.")}
                </p>
              </div>

              {/* 🔍 Search Input */}
              <input
                type="text"
                placeholder={t("Search store")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              {/* 🏬 Retailer Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "12px",
                  maxHeight: "350px",
                  overflowY: "auto",
                  marginBottom: "20px",
                }}
              >
                {filteredRetailers.length > 0 ? (
                  filteredRetailers.map((retailer) => (
                    <div
                      key={retailer.id}
                      onClick={() => setSelectedRetailerId(retailer.id)}
                      className="relative flex items-center py-3 rounded-md mb-1 cursor-pointer border-2"
                      style={{
                        borderColor:
                          selectedRetailerId === retailer.id
                            ? "#1B4597"
                            : "#E3E7EF",
                        backgroundColor:
                          selectedRetailerId === retailer.id
                            ? "#F4FDFF"
                            : "#ffffff",
                      }}
                    >
                      <input
                        type="radio"
                        checked={selectedRetailerId === retailer.id}
                        onChange={() => setSelectedRetailerId(retailer.id)}
                        style={{
                          position: "absolute",
                          top: 10,
                          [isRTL ? "left" : "right"]: 10,
                          width: "15px",
                          height: "15px",
                          transform: "scale(1.3)",
                          accentColor: "#1b4497",
                          cursor: "pointer",
                        }}
                      />
                      {/* <div
                        className="flex items-center justify-center w-3/12 mx-4"
                        style={{ height: 60, width: 70 }}
                      >
                        <img
                          src={retailer.image_url}
                          alt={retailer.retailer_name}
                          className="me-3 rounded-md object-contain"
                          style={{
                            width: "100%",
                            height: "100%",
                            maxWidth: "70px",
                            maxHeight: "60px",
                          }}
                        />
                      </div> */}
                      <div className="w-8/12 flex ms-4">
                        <p className="font-medium text-black text-sm ">
                          {t(retailer.retailer_name)}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="justify-center text-gray-500 ">
                    {t("No stores found.")}
                  </p>
                )}
              </div>

              {/* ✅ Done Button */}
              <button
                style={styles.verifyButton}
                disabled={selectedRetailerId == null}
                onClick={() => {
                  const selectedRetailer = retailers.find(
                    (retailer) => retailer.id === selectedRetailerId
                  );
                  if (selectedRetailer) {
                    LoginWithRetails(selectedRetailer.email, true);
                  }
                }}
              >
                {t("Done")}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SelectLoginRetailers;



// import React, { useState, useEffect } from "react";
// import OtpInput from "react-otp-input";
// import { useFormik } from "formik";
// import { useDispatch } from "react-redux";
// import { verifyOtpUser } from "../components/Actions/verifyOtpActions";
// import TermsModal from "./termsandconditions";
// import { signupActions } from "../components/Redux Slices/signupSlice";
// import { signupUser } from "../components/Actions/signupActions";
// import { Image } from "antd";
// import Edit from "../assets/Edit.svg";
// import { useTranslation } from "react-i18next";
// import {
//   LoginData,
//   sendLoginOTP,
//   verifyLoginOtp,
// } from "../Redux/Action/loginAction";
// import { toast } from "react-toastify";

// const SelectLoginRetailers = ({ retailers, isOpen, onClose, LoginWithRetails }) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useDispatch();
//   const [selectedRetailerId, setSelectedRetailerId] = useState(null);
//   const isRTL = i18n.dir() === "rtl";

//   const styles = {
//     overlay: {
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       backgroundColor: "rgba(0, 0, 0, 0.5)",
//       zIndex: 999,
//     },
//     container: {
//       width: "800px", // increased from 550px
//       maxHeight: "530px", // enough for 3 rows of cards + heading/button
//       padding: "20px",
//       borderRadius: "30px",
//       margin: "0 auto",
//       backgroundColor: "#ffffff",
//       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//       position: "fixed",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       zIndex: 1000,
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//     },
//     title: {
//       fontSize: "1.2rem",
//       fontWeight: "bold",
//       textAlign: "center",
//       marginBottom: "4px",
//       marginTop: "10px",
//     },
//     description: {
//       textAlign: "center",
//       fontSize: "0.9rem",
//       color: "#5C5C5C",
//       marginBottom: "20px",
//     },

//     verifyButton: {
//       opacity: selectedRetailerId === null ? 0.5 : 1,
//       pointerEvents: selectedRetailerId === null ? "none" : "auto", // optional: disable interaction
//       padding: "10px",
//       paddingInline: 40,
//       backgroundColor: "#1b4497",
//       color: "white",
//       borderRadius: "8px",
//       cursor: "pointer",
//       display: "block",
//       marginTop: "10px",
//       marginBottom: "20px",
//       fontWeight: "600",
//       marginLeft: "auto", // aligns to the right
//       marginRight: 0,
//     },
//   };

//   const rett = [
//     {
//       id: 132,
//       retailer_name: "Veer Pal Grocery",
//       image_url: "https://assets.myginne.com/assets/store_app_UAT/132.png",
//     },
//     {
//       id: 391,
//       retailer_name: "Rawan Shop myGINNE",
//       image_url: "https://assets.myginne.com/assets/store_ShopImages/391.png",
//     },
//     {
//       id: 392,
//       retailer_name: "Rawan Shop myGINNE",
//       image_url: "https://assets.myginne.com/assets/store_ShopImages/391.png",
//     },
//     {
//       id: 396,
//       retailer_name: "Rawan Shop myGINNE",
//       image_url: "https://assets.myginne.com/assets/store_ShopImages/391.png",
//     },
//   ];

//   return (
//     <>
//       {isOpen && (
//         <>
//           <div style={styles.overlay} onClick={onClose}></div>
//           <div style={styles.container}>
//             <div>
//               <div>
//                 <p style={styles.title}>{t("Select your Store")}</p>
//                 <div className="flex flex-row justify-center">
//                   <p style={styles.description}>
//                     {t("Please choose a store to continue.")}
//                   </p>
//                 </div>
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(3, 1fr)",
//                     gap: "12px",
//                     maxHeight: "400px", // adjust this height as needed
//                     overflowY: "auto",
//                     marginBottom: "20px",
//                   }}
//                 >
//                   {retailers.map((retailer) => (
//                     <div
//                       key={retailer.id}
//                       onClick={() => setSelectedRetailerId(retailer.id)}
//                       className="relative flex items-center py-3 rounded-md mb-1 cursor-pointer border-2"
//                       style={{
//                         borderColor:
//                           selectedRetailerId === retailer.id
//                             ? "#1B4597"
//                             : "#E3E7EF",
//                         backgroundColor:
//                           selectedRetailerId === retailer.id
//                             ? "#F4FDFF"
//                             : "#ffffff",
//                       }}
//                     >
//                       <input
//                         type="radio"
//                         checked={selectedRetailerId === retailer.id}
//                         onChange={() => setSelectedRetailerId(retailer.id)}
//                         style={{
//                           position: "absolute",
//                           top: 10,
//                           [isRTL ? "left" : "right"]: 10, // dynamically switch based on direction

//                           width: "15px",
//                           height: "15px",
//                           transform: "scale(1.3)", // makes it slightly bigger
//                           accentColor: "#1b4497", // optional: custom color (modern browsers only)
//                           cursor: "pointer",
//                         }}
//                       />
//                       <div
//                         className="flex items-center justify-center w-3/12 mx-4"
//                         style={{ height: 60, width: 70 }}
//                       >
//                         <img
//                           src={retailer.image_url}
//                           alt={retailer.retailer_name}
//                           className="me-3 rounded-md object-contain"
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             maxWidth: "70px",
//                             maxHeight: "60px",
//                           }}
//                         />
//                       </div>
//                       <div className="w-8/12 flex">
//                         <p className="font-medium text-black text-sm ">
//                           {t(retailer.retailer_name)}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 <button
//                   style={styles.verifyButton}
//                   disabled={selectedRetailerId == null}
//                   onClick={() => {
//                     const selectedRetailer = retailers.find(
//                       (retailer) => retailer.id === selectedRetailerId
//                     );
//                     if (selectedRetailer) {
//                       LoginWithRetails(selectedRetailer.email);
//                     }
//                   }}
//                 >
//                   {t("Done")}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default SelectLoginRetailers;